import http from "../utils/http-common";

const baseCombustionPath = "/api/combustion";
const baseTask = "/api/tasks";

// setup/stack-info
export const getYearsOfCombustion = (companyId: string) => {
  return http.get(`${baseCombustionPath}/year/${companyId}`);
};

export const getStackInfoCombustions = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/setup/stack-info/${companyId}?${query}`);
};

export const getStackInfoOptionFilterCombust = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/setup/stack-info/options/filter-stack-info/${companyId}?${query}`);
};

export const deleteStackInfoCombust = (companyId: string, _id: string) => {
  return http.delete(`${baseCombustionPath}/setup/stack-info/${companyId}/${_id}`);
};

export const createStackInfoCombust = (data: any) => {
  return http.post(`${baseCombustionPath}/setup/stack-info`, data);
};

export const updateStackInfoCombust = (companyId: string, _id: string, data: any) => {
  return http.patch(`${baseCombustionPath}/setup/stack-info/${companyId}/${_id}`, data);
};

// setup/fuel-volume
export const updateFuelVolumeCombust = (companyId: string, _id: string, data: any) => {
  return http.patch(`${baseCombustionPath}/setup/fuel-volume/${companyId}/${_id}`, data);
};

export const getFuelVolumeCombustions = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/setup/fuel-volume/${companyId}?${query}`);
};

export const getFuelVolumeOptionFilterCombust = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/setup/fuel-volume/options/filter-fuel-volume/${companyId}?${query}`);
};

// manual/fuel-volume
export const getManualFuelVolumeCombustions = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/manual/fuel-volume/${companyId}?${query}`);
};

export const updateManualFuelVolumeCombust = (companyId: string, _id: string, data: any) => {
  return http.patch(`${baseCombustionPath}/manual/fuel-volume/${companyId}/${_id}`, data);
};

export const getManFuelVolumeOptionFilterCombust = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/manual/fuel-volume/options/filter-manual-fuelvolume/${companyId}?${query}`);
};

// manual/sampling
export const getManualSamplingCombustions = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/manual/sampling/${companyId}?${query}`);
};

export const updateManualSamplingCombust = (companyId: string, _id: string, data: any) => {
  return http.patch(`${baseCombustionPath}/manual/sampling/${companyId}/${_id}`, data);
};

export const uploadFileManualSamplingCombust = (
  companyId: string,
  _id: string,
  month: string,
  year: number,
  formData: FormData,
  onUploadProgress: (progressEvent: ProgressEvent) => void, // Define the type for onUploadProgress callback
) => {
  return http.post(`${baseCombustionPath}/manual/sampling/${companyId}/${_id}/${month}/${year}/upload`, formData, {
    onUploadProgress: onUploadProgress,
  });
};

export const getListFileById = (companyId: string, _id: string, month: string, year: number, data: any) => {
  return http.post(`${baseCombustionPath}/manual/sampling/file/${companyId}/${_id}/${month}/${year}/upload`, data);
};

export const deleteFileManualSampling = (companyId: string, _id: string) => {
  return http.delete(`${baseCombustionPath}/manual/sampling/file/${companyId}/${_id}/combustion`);
};

export const getFileByCombustionId = (companyId: string, combustionId: string) => {
  return http.get(`${baseCombustionPath}/manual/sampling/file/by-combustion-id/${companyId}/${combustionId}`);
};

export const downloadFileSampling = (companyId: string, fileId: string) => {
  return http.get(`${baseCombustionPath}/manual/sampling/download/${companyId}/${fileId}`);
};

// report/fuel-volume
export const getReportFuelVolume = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/report/fuel-volume/${companyId}?${query}`);
};

export const getReportFuelVolumeOptionFilter = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/report/fuel-volume/options/filter-report/${companyId}?${query}`);
};

export const exportExcelFuelVolume = (companyId: string, year: number, query: string) => {
  return http.get(`${baseCombustionPath}/report/fuel-volume/export-excel/${companyId}/${year}?${query}`);
};

// report/voc-emission
export const getReportVocEmission = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/report/voc-emission/${companyId}?${query}`);
};

// report/voc-emission/options/filter-report-emission/:companyId
export const getOptionsFilterReportVocEmission = (companyId: string, query: string) => {
  return http.get(`${baseCombustionPath}/report/voc-emission/options/filter-report-emission/${companyId}?${query}`);
};

export const getOptionMonthSubmit = (companyId: string, year: number) => {
  return http.get(`${baseCombustionPath}/report/voc-emission/approve/month/${companyId}/${year}`);
};

export const getOptionVocApprove = (companyId: string) => {
  return http.get(`${baseCombustionPath}/report/voc-emission/approve/filter-voc-approve/${companyId}`);
};

export const submitReportVoc = (companyId: string, data: any) => {
  return http.post(`${baseCombustionPath}/report/voc-emission/approve/submit-report/${companyId}`, data);
};

export const getInfoStepApprove = (companyId: string, approveId: string) => {
  return http.get(`${baseCombustionPath}/report/voc-emission/approve/info-step/${companyId}/${approveId}`);
};

export const updateApproveStep = (companyId: string, data: any) => {
  return http.patch(`${baseCombustionPath}/report/voc-emission/approve/approve-step/${companyId}`, data);
};

// Get Master
export const getAreaMaster = (companyId: string) => {
  return http.get(`/api/company/area/${companyId}`);
};

export const getMasterData = () => {
  return http.get(`/api/masterdata`);
};

// Get Task
export const getTaskRunning = (query: string) => {
  return http.get(`${baseTask}/get-task-running?${query}`);
};

// Calculate Report Voc Emission after change Master data
export const calculateReportVocEmissionMasterChange = (data: any) => {
  return http.post(`${baseCombustionPath}/report/voc-emission/calculate/change-master`, data);
};

// Calculate Report Voc Emission
export const calculateReportVocEmission = (id: string) => {
  return http.post(`${baseCombustionPath}/report/voc-emission/calculate/${id}`);
};
